import type { Styles } from '@adornis/ass/style.js';
import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { XTableView } from '@adornis/data-view/client/legacy/x-data-view-table.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-data-view-table
 */
@customElement('cr-data-view-table')
export class CrDataViewTable<T extends typeof AdornisEntity> extends XTableView<T> {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        // x-data-view-table renders every cell with an inline `background` (`unset` for normal
        // columns, primary.shade(100) for sticky ones), so the row striping only wins with
        // !important. Restricting to `.cell` keeps the column resize handles (`.border`) intact.
        [`[row]:nth-child(even) > cr-flex.cell:not([active])`]: {
          background: `${this.colors.neutral.shade(50)} !important`,
        },
        [`[row]:nth-child(odd) > cr-flex.cell:not([active])`]: {
          background: `${this.colors.neutral.shade(100)} !important`,
        },
        [`[row] > cr-flex.cell[active]`]: {
          background: `${this.colors.primary.shade(200)} !important`,
        },
        // keep last: same specificity as the striping rules, so source order decides
        [`[row]:hover > cr-flex.cell:not([active])`]: {
          background: `${this.colors.primary.shade(100)} !important`,
        },

        '.header-text': { background: this.colors.neutral.shade(100) },
        '.header-text cr-h4': { fontWeight: '550' },
      },
    ];
  }
}
